import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { camelCase } from 'lodash';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'wouter';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName, useTheme } from '../../contexts/ThemeContext';
import DisplaysForm from '../forms/Displays';
import Logo from '../icons/Logo';

import styles from '../../../styles/displays/displays.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    vertical: PropTypes.bool.isRequired,
};

function Displays({ page, vertical }) {
    const themeClassName = useThemeClassName(styles);
    const { logo = null } = useTheme();
    const { component: logoComponent } = logo || {};

    const route = useUrlGenerator();
    const [, navigate] = useLocation();

    const { displays = null, games = null } = page || {};
    const [firstGame = null] = games || [];

    const onFormSuccess = useCallback(
        ({ display = null }) => {
            navigate(route('display', { display }));
        },
        [route, firstGame],
    );

    // console.log('displays', displays);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.vertical]: vertical,
                },
                themeClassName,
            ])}
        >
            <aside className={styles.sidebar}>
                <Logo
                    component={logoComponent}
                    className={classNames([
                        styles.logo,
                        {
                            [styles[camelCase(logoComponent)]]: logoComponent !== null,
                        },
                    ])}
                />
            </aside>
            <main className={styles.box}>
                <DisplaysForm
                    displays={displays}
                    onSuccess={onFormSuccess}
                    withoutRegions
                    displaysPlaceholder={
                        <FormattedMessage
                            defaultMessage="Select your screen"
                            description="Placeholder label"
                        />
                    }
                />
            </main>
        </div>
    );
}

Displays.propTypes = propTypes;

export default Displays;
